module.exports = __webpack_public_path__ + "img/10.b2757c1e.png";